import type { Source } from '@/types/nestjs';

export const findSelectedSource = (developerSources: Source[], developer: number | null) =>
  developerSources.find((value) => value.id === developer);
